import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useCallback, useEffect, useState } from "react";
import { enqueueSnackbar } from "notistack";
import CartaoForm from "./CartaoForm";
import ChequeForm from "./ChequeForm";
import { IInternForm } from "../DialogCadastrarRecb";
import PaperDraggable from "../../../../../../../../../../../components/PaperDraggable";

export default function DialogFormRecb({
  index,
  open,
  item,
  handleClose,
}: DialogFormEspecificoProps) {
  const { setValue, getValues } = useFormContext();
  const [formData, setFormData] = useState<IInternForm>(item || {} as IInternForm);

  useEffect(() => {
    if (item) {
      setFormData(item);
    }
  }, [item]);

  const handleChangeValues = (prop: string | number | symbol, value: any) => {
    setFormData((prev) => ({
      ...prev,
      [prop]: value,
    }));
  };

  const handleSubmit = useCallback(() => {
    const recebimentos = getValues("finalizacao.recebimentos");

    if (formData.formaPagamento?.requerNsu){
      const erros = validarCartaoForm(formData);
      if (erros.length > 0) {
        enqueueSnackbar(erros[0], { variant: "error" });
        return;
      }
    }

    if (formData.formaPagamento?.requerChequeInfo) {
      const erros = validarChequeForm(formData);
      if (erros.length > 0) {
        enqueueSnackbar(erros[0], { variant: "error" });
        return;
      }
    }

    if (index !== -1) {
      recebimentos[index] = { ...recebimentos[index], ...formData };
      setValue("finalizacao.recebimentos", recebimentos);
      enqueueSnackbar("Informações atualizadas com sucesso", { variant: "success" });
      handleClose();
    } else {
      enqueueSnackbar("Erro ao atualizar informações", { variant: "error" });
    }
  }, [index, formData, getValues, setValue, handleClose]);

  const getFormComponent = () => {
    if (!item?.formaPagamento) return null;

    // Verificar se é cartão
    if (item.formaPagamento.requerNsu) {
      return (
        <CartaoForm
          values={formData}
          handleChangeValues={handleChangeValues}
        />
      );
    }

    // Verificar se é cheque
    if (item.formaPagamento.requerChequeInfo) {
      return (
        <ChequeForm
          values={formData}
          handleChangeValues={handleChangeValues}
        />
      );
    }

    return (
      <Typography variant="body2" color="text.secondary">
        Esta forma de pagamento não requer informações adicionais.
      </Typography>
    );
  };

  const getDialogTitle = () => {
    if (!item?.formaPagamento) return "Formulário Específico";

    if (item.formaPagamento.requerNsu) {
      return "Informações do Cartão";
    }

    if (item.formaPagamento.requerChequeInfo) {
      return "Informações do Cheque";
    }

    return "Formulário Específico";
  };

  return (
    <Dialog
      open={open}
      PaperComponent={PaperDraggable}
      aria-labelledby="draggable-dialog-title"
      scroll="body"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
        {getDialogTitle()}
      </DialogTitle>

      <DialogContent>
        <Grid container spacing={2} my={1}>
          <Grid size={{xs: 12}}>
            <Stack
              direction="row"
              justifyContent="space-between"
              spacing={2}
              sx={{ p: 1, bgcolor: 'grey.50', borderRadius: 1 }}
            >
              <Typography variant="subtitle2" color="text.secondary">
                Forma de pagamento: <strong>{item?.formaPagamento?.label}</strong>
              </Typography>
              <Typography variant="subtitle2" color="text.secondary">
                Valor: <strong>R$ {item?.valor}</strong>
              </Typography>
            </Stack>
          </Grid>

          <Grid size={{xs: 12}}>
            {getFormComponent()}
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button variant="contained" onClick={handleSubmit}>
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

interface DialogFormEspecificoProps {
  open: boolean;
  item: IInternForm | null;
  index: number;
  handleClose: () => void;
}


function validarChequeForm(formData: IInternForm) {
  const errors: string[] = [];

  if (!formData.cheque_data_vencimento) {
    errors.push("A data de vencimento do cheque é obrigatória.");
  }

  if (!formData.cheque_conta_contabil) {
    errors.push("A conta contábil do cheque é obrigatória.");
  }

  if (!formData.cheque_num) {
    errors.push("O número do cheque é obrigatório.");
  }

  if (!formData.cheque_seq) {
    errors.push("O sequencial do cheque é obrigatório.");
  }

  if (!formData.cheque_banco) {
    errors.push("O banco do cheque é obrigatório.");
  }

  if (!formData.cheque_nome_emissor) {
    errors.push("O nome do emissor do cheque é obrigatório.");
  }

  if (!formData.cheque_documento) {
    errors.push("O CPF/CNPJ do emissor do cheque é obrigatório.");
  }

  if (!formData.cheque_praca) {
    errors.push("A praça do cheque é obrigatória.");
  }

  return errors;
}

function validarCartaoForm(formData: IInternForm) {
  const errors: string[] = [];

  if (!formData.cartao_nsu) {
    errors.push("O NSU do cartão é obrigatório.");
  }

  if (!formData.cartao_autorizacao) {
    errors.push("O código de autorização do cartão é obrigatório.");
  }

  return errors;
}